import React from 'react'
import Layout from '../layout/default';
function Blank() {
  return (
    <Layout title="Blank">Blank</Layout>
  )
}

export default Blank